import { useNuxtApp } from "nuxt/app";
import type posthog from "posthog-js";

export const usePostHog = (): posthog | null => {
  const nuxtApp = useNuxtApp();
  return (nuxtApp.$posthog as posthog | null) ?? null;
};
